// Official B.health logo (transparent background) — works on light and dark surfaces.
export function Logo({ imgClassName = "h-10", className = "" }) {
  return (
    <img
      src="/logo-bhealth.png"
      alt="B.health® — Restart your body"
      className={`w-auto ${imgClassName} ${className}`}
      data-testid="bhealth-logo"
    />
  );
}
